import React from 'react'
import { faPencilAlt, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import {
  DcButton,
  DcOverlaySlider,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  SectionContent,
} from 'pixel-base'
import styled from 'styled-components'

import { deleteCustomerAddress } from 'utils/api-routes.util'

import AddNewAddress from './AddNewAddress'
import EditCustomerAddress from './EditCustomerAddress'
import { IPixelFactory } from '../../../../../../../decl'

const Address = (props) => {
  const address_type = props.addressType
  const addressname = Object.keys(props.address)
  const [address, setAddress] = React.useState<object>({})
  const [showModal, setShowModal] = React.useState(false)
  const [showAddressModal, setShowAddressModal] = React.useState(false)
  const [countries] = React.useState(props.countries)

  const {
    showPageLoader,
    hidePageLoader,
    showSuccess,
    showFailure,
    pixelConfirm,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const handleDelete = () => {
    pixelConfirm({
      title: 'Delete Address',
      message:
        'Are you sure? you want to delete this address, This action cannot be undone.',
      onConfirm: () => {
        showPageLoader()
        deleteCustomerAddress(props.customer_id, address?.address_id).subscribe(
          (res) => {
            hidePageLoader()

            if (res.response?.message !== 'error') {
              showSuccess('Address deleted successfully')
            } else {
              showFailure(
                `Something went wrong, ${res.response?.message_detail}`,
              )
            }
          },
        )
      },
    })
  }

  React.useEffect(() => {
    if (props.address) {
      if (props.address.shippingAddress) {
        setAddress(props.address.shippingAddress)
      } else if (props.address.billingAddress) {
        setAddress(props.address.billingAddress)
      }
    } else {
      setAddress({})
    }
  }, [props.address])

  return (
    <>
      <PixelFlexBox
        style={{
          flexDirection: 'column',
          padding: '10px 20px',
          background: '#e9ecef78',
          color: '#000',
          boxShadow: ' 0px 0px 3px 0px rgba(0, 0, 0, 0.2)',
          marginBottom: '15px',
          position: 'relative',
        }}
      >
        {Object?.keys(address || {})?.length !== 0 ? (
          <>
            <AddressActions>
              {!props.isItInvoice ? (
                <>
                  <DcButton
                    variant="outline-primary"
                    size="sm"
                    tooltip="Edit Address"
                    onClick={() => setShowAddressModal(true)}
                  >
                    <PixelIcon
                      color="inherit"
                      className="icon"
                      icon={faPencilAlt}
                    />
                  </DcButton>
                  <DcButton
                    onClick={handleDelete}
                    variant="outline-danger"
                    size="sm"
                    tooltip="Delete"
                    style={{ background: '#fff' }}
                  >
                    <PixelIcon
                      icon={faTrash}
                      color="inherit"
                      className="delete"
                    />
                  </DcButton>
                </>
              ) : (
                <>
                  <DcButton onClick={() => props.handleClick(address)}>
                    Select
                  </DcButton>
                </>
              )}
            </AddressActions>
            <CustomerInfo>
              {address?.first_name} {address?.last_name}
            </CustomerInfo>
            <AddressInfo>
              {address?.address1} {address?.address2}
            </AddressInfo>
            <AddressInfo>{address?.phone}</AddressInfo>
            <AddressInfo>
              {address?.city} {address?.state_name} {address?.zip}
            </AddressInfo>
          </>
        ) : (
          <PixelFlexBox justifyContent="center">
            <DcButton
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setShowModal(true)
              }}
            >
              <PixelIcon icon={faPlus} />
              {addressname[0] == 'billingAddress'
                ? 'Add Billing Address'
                : 'Add Shipping Address'}
            </DcButton>
          </PixelFlexBox>
        )}
      </PixelFlexBox>
      <DcOverlaySlider
        width={'50%'}
        title={'Edit Address'}
        onClose={() => setShowAddressModal(false)}
        isOpen={showAddressModal}
      >
        <SectionContent>
          <EditCustomerAddress
            address={address}
            countries={countries}
            customer_id={props.customer_id}
            addressType={props.addressType}
            handleClose={(data) => {
              setShowAddressModal(false)
              if (data) setAddress(data)
            }}
          />
        </SectionContent>
      </DcOverlaySlider>
      <DcOverlaySlider
        width={'50%'}
        title={`Create ${
          addressname[0] == 'billingAddress' ? ' Billing ' : ' Shipping '
        } Address`}
        onClose={() => setShowModal(false)}
        isOpen={showModal}
      >
        <SectionContent>
          <AddNewAddress
            customer_id={props.customer_id}
            addressType={address_type}
            countries={props.countries}
            handleClose={(address) => {
              setAddress(address)
              setShowModal(false)
            }}
          />
        </SectionContent>
      </DcOverlaySlider>
    </>
  )
}

const CustomerInfo = styled.div`
  font-weight: 700;
`
const AddressInfo = styled.div`
  width: 90%;
`

const AddressActions = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
  gap: 10px;
  .icon {
    // color: grey;
  }
  .active-icon {
    color: green;
  }
  .delete {
    color: red;
  }
`
export default Address
